<div class="header" [ngClass]="{ scrolled: isScrolled }">
  <div class="header-inner">
    <!-- BRAND -->
    <div class="header-brand" (click)="navHome()">
      <!-- <span class="brand-mark">A</span> -->
      <h3 class="brand-name">
        Angularize
        <!-- <span class="beta-pill" *ngIf="isBeta">Beta</span> -->
      </h3>
    </div>

    <!-- PRIMARY NAV (desktop) -->
    <nav class="primary-nav hide-in-phone" aria-label="Primary">
      <a routerLink="/about-us" routerLinkActive="active-link" class="nav-link">About</a>
      <a routerLink="/pricing" routerLinkActive="active-link" class="nav-link">Pricing</a>
      <a
        routerLink="/"
        fragment="community"
        class="nav-link"
        [class.active-link]="isCommunityActive()"
        >Community</a
      >
      <a routerLink="/contact-us" routerLinkActive="active-link" class="nav-link">Contact</a>
      <a routerLink="/docs" routerLinkActive="active-link" class="nav-link">Documentation</a>
    </nav>

    <!-- RIGHT CLUSTER -->
    <div
      class="header-actions"
      *ngIf="{ data: user$ | async } as auth"
    >
      <!-- Admin — a distinct, dark chip. Independent of partner status:
           both can show at once if someone is genuinely both. -->
      <button
        *ngIf="isAdmin"
        type="button"
        class="role-chip role-chip--admin hide-in-phone"
        (click)="goToAdminHub()"
        matTooltip="Admin Hub"
      >
        <mat-icon>admin_panel_settings</mat-icon>
        <span>Admin</span>
      </button>

      <!-- Partner — an "earned status" chip (gradient + shimmer), not a
           plain nav link, for an approved active partner. -->
      <a
        *ngIf="isPartnerViewer"
        routerLink="/execution-partners/dashboard"
        class="role-chip role-chip--partner hide-in-phone"
        matTooltip="Your Partner Dashboard"
      >
        <mat-icon>dashboard</mat-icon>
        <span>Partner Dashboard</span>
      </a>

      <!-- Not yet a partner — a quiet, low-priority ghost link so it's
           discoverable without competing with the primary nav or CTA. -->
      <a
        *ngIf="!isPartnerViewer"
        routerLink="/execution-partners"
        class="role-chip role-chip--ghost hide-in-phone"
        matTooltip="Apply to join our team of execution partners"
      >
        <mat-icon>handshake</mat-icon>
        <span>Join us</span>
      </a>

      <app-user-menu *ngIf="auth.data" [user]="auth.data"></app-user-menu>

      <button
        *ngIf="!auth.data"
        type="button"
        class="cta-btn hide-in-phone"
        (click)="login()"
      >
        <span>Get Started</span>
        <mat-icon>arrow_forward</mat-icon>
      </button>

      <button
        mat-icon-button
        class="hide-in-desktop menu-trigger"
        (click)="toggleMenu()"
        aria-label="Open menu"
      >
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  </div>
</div>

<!-- MOBILE MENU OVERLAY -->
<div class="menu-overlay" *ngIf="menuOpen">
  <div class="close-container">
    <button mat-icon-button (click)="toggleMenu()" aria-label="Close menu">
      <mat-icon style="color: #c3002f">close</mat-icon>
    </button>
  </div>
  <div class="menu-links">
    <a
      routerLink="/about-us"
      routerLinkActive="active-link"
      (click)="toggleMenu()"
      class="menu-link-ph"
      >About</a
    >
    <a
      routerLink="/pricing"
      routerLinkActive="active-link"
      (click)="toggleMenu()"
      class="menu-link-ph"
      >Pricing</a
    >
    <a
      routerLink="/"
      fragment="community"
      [class.active-link]="isCommunityActive()"
      (click)="toggleMenu()"
      class="menu-link-ph"
      >Community</a
    >
    <a
      routerLink="/contact-us"
      routerLinkActive="active-link"
      (click)="toggleMenu()"
      class="menu-link-ph"
      >Contact us</a
    >
    <a
      routerLink="/docs"
      routerLinkActive="active-link"
      (click)="toggleMenu()"
      class="menu-link-ph"
      >Read Docs</a
    >

    <!-- Admin — visually distinct (accent modifier) from the plain links
         above, same treatment "earned status" gets on desktop. -->
    <a
      *ngIf="isAdmin"
      (click)="goToAdminHub(); toggleMenu()"
      class="menu-link-ph menu-link-ph--accent"
    >
      <mat-icon class="menu-link-ph__icon">admin_panel_settings</mat-icon>Admin Hub</a
    >

    <a
      *ngIf="isPartnerViewer"
      routerLink="/execution-partners/dashboard"
      routerLinkActive="active-link"
      (click)="toggleMenu()"
      class="menu-link-ph menu-link-ph--accent"
    >
      <mat-icon class="menu-link-ph__icon">dashboard</mat-icon>Dashboard</a
    >
    <a
      *ngIf="!isPartnerViewer"
      routerLink="/execution-partners"
      routerLinkActive="active-link"
      (click)="toggleMenu()"
      class="menu-link-ph"
      >Join us</a
    >

    <div class="menu-cta-row">
      <ng-container *ngIf="user$ | async as user; else guestMobile">
        <button
          color="warn"
          mat-stroked-button
          class="matButton1"
          (click)="logout(); toggleMenu()"
          style="border-color: #f44336; color: #f44336"
        >
          <mat-icon>logout</mat-icon> Logout
        </button>
      </ng-container>
      <ng-template #guestMobile>
        <button
          type="button"
          class="cta-btn cta-btn--mobile"
          (click)="login(); toggleMenu()"
        >
          <span>Get Started</span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </ng-template>
    </div>
  </div>
</div>

<div *ngIf="isLoading" class="loading-overlay">
  <mat-spinner diameter="60"></mat-spinner>
  <p class="loading-text">{{ statusMessage || "Loading..." }}</p>
</div>